// extracted by mini-css-extract-plugin
module.exports = {"countdown-number":"VideoChatSection_countdown-number__2REUh","countdown-title":"VideoChatSection_countdown-title__Bo1E8"};